import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import AreaID from "../../../components/ecoUser/areaID/AreaID";
import Limits from "../../../components/ecoUser/limits/Limits";

export default function Ecology() {
  const [currentArea, setCurrentArea] = useState("");
  const [areasData, setAreasData] = useState({});
  const [networksData, setNetworksData] = useState({});

  const { areas, isEcologyPending, areasList, networks } = useOutletContext();

  useEffect(() => {
    if (!isEcologyPending) {
      setAreasData(areas);
      setNetworksData(networks)
      setCurrentArea(Object.keys(areas)[0]);
    }
  }, [areas, networks, isEcologyPending]);

  return (
    <div className="eco">
      <AreaID
        areasList={areasList}
        isPending={isEcologyPending}
        setCurrentArea={setCurrentArea}
      />
      <Limits
        areasData={areasData}
        networksData={networksData}
        setAreasData={setAreasData}
        isPending={isEcologyPending}
        currentArea={currentArea}
        areasList={areasList}
      />
    </div>
  );
}
